import React from "react";
import InputMask from "react-input-mask";
import { Box, Stack, TextField } from "@mui/material";
const MaskedTextField = ({
  mask,
  placeholder,
  value,
  type,
  name,
  heading,
  onChange,
  isDisabled = false,
  isError = false,
  errorMessage = "",
}) => {
  return (
    <InputMask mask={mask} name={name} value={value}>
      {(inputProps) => (
        <Stack spacing={1}>
          <Box className="font-16 font-weight-600 line-height-24 black-heading  font-family ">
            {heading}{" "}
          </Box>
          <TextField
            {...inputProps}
            placeholder={placeholder}
            variant="outlined"
            onChange={(event) => onChange(event)}
            error={isError}
            helperText={errorMessage}
            sx={{
              padding: "0px",
              borderRadius: "0px",
              height: "40px !important",
              "& .MuiOutlinedInput-input": {
                padding: "8.5px 14px !important",
              },
              placeholderChar: "\u2000",
            }}
            InputProps={{
              inputProps: {
                placeholderChar: "\u2000", // Disable placeholder line
              },
            }}
            margin="normal"
          />
        </Stack>
      )}
    </InputMask>
  );
};

export default MaskedTextField;
